import { globalStorage } from "../helpers";

export default function useGlobalParams() {
  return {
    organization_id: globalStorage.getItem("fin_user_data")?.organization_code,
    username: globalStorage.getItem("fin_user_data")?.username,
    signature: globalStorage.getItem("fin_user_data")?.signature,
    db_year: globalStorage.getItem("fin_year_data") || "",
  };
}
